import * as React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { PageTitle } from '../../../../../widgets/PageTitle';
import Viewport from '../../../../../widgets/Viewport';
import ViewHeader from '../../../../../widgets/ViewHeader';
import { OnboardingScannerForm } from './Form';
import { ROUTE_PATH } from '../../../../../constants';
import {
  EMPTY_SCANNER,
  getScannerModelFromFormValues,
  ScannerFormValues,
} from './constants';
import { ONBOARDING_ACTIONS } from '../../../../../actions/onboarding';
import { apiRequest } from '../../../../../APIClient';
import { useDispatch } from 'react-redux';
import { createSensorScannerValidationSchema } from '../../../validationSchemas';
import { Formik } from 'formik';
import { ScrollSectionKeys } from '../../OnboardingSiteConfig';

export const OnboardingScannerAddView: React.FunctionComponent = () => {
  const dispatch = useDispatch();

  const onSubmitScanner = React.useCallback(
    (values: ScannerFormValues) => {
      const scanner = getScannerModelFromFormValues(values);
      dispatch(ONBOARDING_ACTIONS.ADD_SCANNER(scanner));
      dispatch(apiRequest.saveOBScanners());
    },
    [dispatch],
  );

  return (
    <Viewport>
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to={ROUTE_PATH.ONBOARDING.MAIN}>Onboarding Overview</Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Configure Scanner</BreadcrumbItem>
      </Breadcrumb>
      <PageTitle title="Configure Scanner" />
      <ViewHeader title="Configure Scanner" />
      <Formik
        initialValues={EMPTY_SCANNER}
        onSubmit={onSubmitScanner}
        validationSchema={createSensorScannerValidationSchema()}
      >
        <OnboardingScannerForm
          showSaveAndAdd
          view={ScrollSectionKeys.SCANNERS}
        />
      </Formik>
    </Viewport>
  );
};
